// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__hTb3g","hide":"Loader_hide__qgwBC","ring":"Loader_ring__9ZyGZ","spin":"Loader_spin__9J5IB","mark":"Loader_mark__fjAAo"};